var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"content"},[_c('i',{staticClass:"el-icon-warning icon"}),(_vm.text)?_c('p',[_vm._v(_vm._s(_vm.text))]):_c('p',[_vm._v(_vm._s(_vm.$t('result.error')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }